import { Box, Typography } from "@mui/material";

import { T } from "components/util/t";
import { Sx } from "utils/sx";

import { Action } from "./Action";
import background1 from "./background-log-in-1.jpg";
import background2 from "./background-log-in-2.jpg";
import background3 from "./background-log-in-3.jpg";

const wrapperStyles: Sx = (theme) => ({
    position: "absolute",
    paddingTop: 7.5,
    top: 0,
    width: "100%",
    minHeight: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    backgroundImage: `url(${backgroundImage})`,
    [theme.breakpoints.down("md")]: {
        backgroundImage: "none",
    },
});

const backgroundImages = [background1, background2, background3] as const;
const backgroundImage = backgroundImages[Math.floor(Math.random() * 3)];
const loginCardStyles: Sx = (theme) => ({
    margin: theme.spacing(8, 0),
    [theme.breakpoints.down("md")]: {
        margin: 0,
    },
});

type AccountFormPageProps = {
    title: string;
    actionText?: string;
    actionButtonText?: string;
    actionClick?: () => void;
    children: React.ReactNode;
};

export const AccountFormPage = ({
    title,
    actionText,
    actionButtonText,
    actionClick,
    children,
}: AccountFormPageProps) => {
    return (
        <Box sx={wrapperStyles}>
            <Box sx={loginCardStyles} className="login-card login-page-card">
                <Typography variant="h1">
                    <T>{title}</T>
                </Typography>
                {actionText && (
                    <Action
                        text={actionText}
                        buttonText={actionButtonText}
                        onClick={actionClick}
                    />
                )}
                {children}
            </Box>
        </Box>
    );
};
